// import { Component, Inject, OnDestroy } from '@angular/core';
import {Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {SlideshowService} from '../slideshow.service';
import {ApiService} from '../../shared/api.service';
import {ImagesService} from '../../shared/images.service';
import {Utils} from '../../utils';
import { PermissionsService } from '../../shared/permissions.service';
import { Permissions } from '../../shared/permissions.enum';

@Component({
    selector: 'meta-component',
    templateUrl: 'meta.component.html'
})
export class MetaComponent implements OnDestroy {
    publishSubscription;
    user;
    userCanEdit;
    taxonomyOptions = [];
    heartbeatSubscription;
    metaTabMetaTitle = this.utils.rand();

    get Permissions() {
        return Permissions;
    }
    
    constructor(
        private api: ApiService,
        private dialog: MatDialog,
        public slideshow: SlideshowService,
        public utils: Utils,
        public permissionsService: PermissionsService,
    ) {
        let user = api.getProp('user');
        this.user = user;
        this.userCanEdit = permissionsService.userHasPermission(Permissions.AssignmentMeta);
        this.setTaxes();
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            setTimeout(() => {
                this.setTaxes();
                this.setTaxOptions();
            }, 1000);            
        });
    }
    ngAfterViewInit() {
        if( this.slideshow.assignment ) {
            this.setTaxOptions();
        } else {
            this.slideshow.assignmentLoaded.subscribe(data => {
                this.setTaxOptions();
            });
        }        
    }
    setTaxes() {
        const taxonomies = this.slideshow.taxonomyOptions;
        const taxKeys = Object.keys(taxonomies);
        const options = [];
        for(var i = 0; i < taxKeys.length; i++) {
            const key = taxKeys[i];
            const tax = taxonomies[key];
            options.push(tax);
        }
        this.taxonomyOptions = options;
    }
    setTaxOptions() {
        const assignment = this.slideshow.assignment || {};
        if( assignment.taxonomies ) {
            const taxes = this.taxonomyOptions;
            const assignmentTaxes = assignment.taxonomies;
            for(var i = 0; i < taxes.length; i++) {
                const tax = taxes[i];
                const slug = tax.slug;
                const options = tax.options;
                if( assignmentTaxes[slug] ) {
                    const slugs = assignmentTaxes[slug].map(item => item.slug);
                    for(var j = 0; j < options.length; j++) {
                        const option = options[j];
                        option.checked = false;
                        if( slugs.indexOf(option.slug) !== -1 ) {
                            option.checked = true;
                        }
                    }
                } else {
                    for(var k = 0; k < options.length; k++) {
                        options[k].checked = false;
                    }
                }
            }
        }
    }
    updateMetaTitle() {
        this.slideshow.slides[0].metaTitle = this.slideshow.assignment.metaTitle;
    }
    updateMetaDesc() {
        this.slideshow.slides[0].metaDescription = this.slideshow.assignment.metaDescription;
    }
    removeTerm(option, tax) {
        const assignment = this.slideshow.assignment;
        const terms = assignment.taxonomies[tax.slug];
        let i = terms.length;
        while(i--) {
            if( terms[i].slug == option.slug ) {
                terms.splice(i, 1);
                if( terms.length == 0 ) {
                    delete assignment.taxonomies[tax.slug];
                }
            }
        }
    }
    addTerm(option, tax) {
        const assignment = this.slideshow.assignment;
        const slug = tax.slug;
        if( !Array.isArray(assignment.taxonomies[slug]) ) {
            assignment.taxonomies[slug] = [];
        }
        assignment.taxonomies[slug].push({
            term_id: option.term_id,
            name: option.name,
            slug: option.slug
        });
    }
    selectOption(option, tax) {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        if( option.checked ) {
            option.checked = false;
            this.removeTerm(option, tax);
        } else {
            option.checked = true;
            this.addTerm(option, tax);
        }
    }
    ngOnDestroy() {
        if( this.publishSubscription ) {
            this.publishSubscription.unsubscribe();
        }
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
    resetImages() {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        this.slideshow.assignment.metaImage = '';
    }
    openImages() {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        const dialog = this.dialog.open(ImagesDialog, {
            data: {
                assignment: this.slideshow.assignment
            }
        });
        dialog.afterClosed().subscribe(details => {
            if( details ) {
               this.slideshow.assignment.metaImage = details.url;
            }
        });
    }
}

@Component({
    selector: 'images-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Select Image
        </div>
        
        <mat-dialog-content 
            id="image-select" 
            dndDropzone 
            (dndDrop)="drop($event)"
            [dndAllowExternal]="true">
            <div class="placeholder">
                <mat-icon>insert_photo</mat-icon>
            </div>
            <div class="images">
                <div class="image"
                    *ngFor="let image of imagesService.images" 
                    (click)="selectImage(image)"
                    [ngStyle]="{
                        'background-image' : 'url(' + image.url + '?width=1200&height=630)'
                    }">
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img *ngIf="imagesService.uploadInProgress" src="/wp-content/themes/swarm/app/assets/images/loading.gif" class="loader"/>
            <button class="button" [mat-dialog-close]="false">Close</button>
        </mat-dialog-actions>`,
})
export class ImagesDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ImagesDialog>, public imagesService: ImagesService) {}
    selectImage(image) {
        const url = image.url + '?width=1200&height=630';
        this.dialogRef.close({
            url: url,
            width: 1200,
            height: 630,
            alt: image.alt
        });
    }
    drop(e) {
        const files = e.event.dataTransfer.files;
        let count = files.length;
        const imageUploadSubscription = this.imagesService.imageUploaded.subscribe(img => {
            count -= 1;
            if( !img.error ) {
                this.selectImage(img);
            }
            if( count == 0 ) {
                imageUploadSubscription.unsubscribe();
            }
        });
        this.imagesService.handleDropFiles(files, this.data.assignment, true);
    }
}